import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SignUpPrimaryStepsContainer } from 'src/domains/players/webview/components/SignUp/signupPrimary/SignupStepsContainer';
import { OperatorTurnOffSignUp } from './operatorTurnOffSignUp/operatorTurnOffSignUp';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

export const SignUp = observer('SignUp', (): JSX.Element => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { signupTurnOffForLeavingOperator } = configState;
    const appPlayersState = AppPlayersState.get(common);

    const { signUpState } = appPlayersState;

    if (signupTurnOffForLeavingOperator.enabled) {
        return (
            <OperatorTurnOffSignUp
                operatorName={signupTurnOffForLeavingOperator.operatorName}
                date={signupTurnOffForLeavingOperator.date}
            />
        );
    }

    return <SignUpPrimaryStepsContainer signUpState={signUpState} />;
});
